import { IUtilityService } from "@common/service/util.service";
import angular from "angular";


function ignoreSpace($_util: IUtilityService) {
    return function (options, input) {
        if (!!input) {
            let results = [];
            if (angular.isObject(input)) {
                angular.forEach(options, function (opt) {
                    for (let key of Object.keys(input)) {
                        let inp = $_util.removeExtraSpace(input[key]);
                        if ($_util.removeExtraSpace(opt[key]).includes(inp)) {
                            results.push(opt);
                            break;
                        }
                    };
                });
                return results;
            } else if (typeof input == "string") {
                let inp = $_util.removeExtraSpace(input);
                let keys = Object.keys(options);
                angular.forEach(options, function (opt) {
                    for (let key of keys) {
                        if ($_util.removeExtraSpace(opt[key]).includes(inp)) {
                            results.push(opt);
                            break;
                        }
                    }

                });
                return results;
            }
        }
        return options;
    }

}

angular.module('eCareVault.common.filters').filter('ignoreSpace', ["UtilityService", ignoreSpace]);
